/* */
/**
 * @module constants/RegisterActions
 */

/**
 * The exposed, namespaced Register related actions.
 */
export const RegisterActions = Object.freeze({
  REGISTER_LISTENER: 'REGISTER_LISTENER',
  REGISTER_RESET: 'REGISTER_RESET',
  REGISTER_BLOCKED: 'REGISTER_BLOCKED',
  REGISTER_CLEAR_ERROR: 'REGISTER_CLEAR_ERROR',
} as const);

export const RegisterStatsActions = Object.freeze({
  REGISTER_SCREEN_SHOWN: 'registration_screen_shown',
} as const);

export default RegisterActions;
